import {Pipe, PipeTransform} from '@angular/core';
import {RESOURCE_TYPES} from '../shape-spawn-data/resources.model';

@Pipe({
  name: 'resourceType',
  pure: true,
  standalone: true
})
export class ResourceTypePipe implements PipeTransform {
  transform(type: string): string {
    return RESOURCE_TYPES[type];
  }
}
